import React, { useState } from 'react'
import InputMask from 'react-input-mask'

const PhoneInput = ({ error, label, ...rest }) => {
  const [mask, setMask] = useState('(99) 99999-9999')
  const [touched, setTouched] = useState(false)

  return (
    <>
      <label htmlFor={rest.name}>{label}</label>
      <InputMask
        className='form-control'
        {...rest}
        mask={mask}
        onBlur={(e) => {
          setTouched(true)
          if (e.target.value.replace('_', '').length === 14) {
            setMask('(99) 9999-9999')
          }
        }}
        onFocus={(e) => {
          setTouched(true)
          if (e.target.value.replace('_', '').length === 14) {
            setMask('(99) 99999-9999')
          }
        }}
      >
        {(inputProps) => <input {...inputProps} type='tel' />}
      </InputMask>
      <span className='text-danger'>{touched && error}</span>
    </>
  )
}

export default PhoneInput
